import {createContext} from 'react';

export const leftElResizeContext = createContext(0);
